<template>
  <b-modal id="reason-prompt-modal"
           size="sm"
           :title="$t('write_reason')"
           @hide="onHide"
           v-model="visible"
           centered>
    <div class="">

        <b-list-group class="gap-0">
          <b-list-group-item v-for="record_reason in record_reasons"
                             href="#"
               :key="`r-r-${record_reason.id}`"
                             class="pointer py-2"
                             @click="selectOption(record_reason.title)">
            {{ record_reason.title }}
          </b-list-group-item>
        </b-list-group>

      <div class="pt-3">

        <InputGroup v-model="inputValue"
                    :placeholder="$t('or_write_other_reason')"/>
      </div>
    </div>
    <template #modal-footer>
      <div class="modal-footer-buttons no-print">
        <b-button class="cancel mr-md-3 mr-2 d-inline-block align-middle"
                  variant="themed"
                  @click="cancel">
          {{ $t('cancel') }}
        </b-button>
        <button @click="submit"
                class="btn-themed align-middle btn-themed-squared">OK</button>
      </div>

    </template>
  </b-modal>
</template>

<script setup>
import InputGroup from "@/components/form/InputGroup.vue"
import { computed, ref } from "vue"
import { useStore } from "vuex"

const store = useStore()

const visible = ref(false)
const inputValue = ref('')
// of the promise given to the one who asked
let resolve = null

const record_reasons = computed(() => store.state.auth.record_reasons)

const hide = () => {
  visible.value = false
  inputValue.value = ''
}

// opens the prompt; resolves with the reason, or null when cancelled
const showPrompt = () => {
  visible.value = true
  return new Promise((res) => {
    resolve = res
  })
}

const submit = () => {
  resolve(inputValue.value)
  hide()
}

const cancel = () => {
  resolve(null)
  hide()
}

const onHide = () => {
  resolve(null)
}

const selectOption = (text) => {
  resolve(text)
  hide()
}

defineExpose({
  showPrompt,
})
</script>
